import { HorizontalLegend } from './HorizontalLegend/HorizontalLegend';
import { VerticalLegend } from './VerticalLegend/VerticalLegend';
import type { ResponsiveLegendProps } from './ResponsiveLegend.types';

export const ResponsiveLegend = ({
  orientation = 'horizontal',
  legend_items,
  ...props
}: ResponsiveLegendProps): React.JSX.Element | null => {
  if (!legend_items?.length) return null;

  if (orientation === 'vertical') return <VerticalLegend legend_items={legend_items} {...props} />;
  return <HorizontalLegend legend_items={legend_items} {...props} />;
};
